/**
 * User list item (JSDoc-only export for page imports)
 * @typedef UserItem
 * @type {Object}
 * @property {Number} id
 * @property {String} name
 * @property {String} role
 * @property {Object} home
 * @property {Object} project
 * @property {String} mobileNo
 * @property {String} email
 */
export const UserItem = {}

/**
 * Import item properties
 * @typedef UserInput
 * @type {Object}
 * @property {Number} [id]      - User ID
 * @property {String} [homeId]  - Home DI
 * @property {String} firstName - First name
 * @property {String} lastName  - Last name
 * @property {String} role      - OWNER, RESIDENT, and RENTER
 * @property {String} mobileNo  - Mobile number
 * @property {String} email     - Email
 */

export class NonScUserCommon {
  
  /** @type {UserInput} */
  static input = {
    id        : null,
    firstName : null,
    lastName  : null,
    role      : 'OWNER',
    mobileNo  : null,
    email     : null,
  }

  /** @type {UserItem} */
  static item = {
    id        : null,
    name      : null,
    role      : null,
    home      : null,
    project   : null,
    mobileNo  : null,
    email     : null,
  }
}